import React, {
    memo,
} from 'react';

import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';

import dynamic from 'next/dynamic';

import { ErrorBoundary } from '@bonnet/next/error-boundary';

import savedInventoryDuck from '@/ducks/savedInventoryDuck.js';

import LazyComponent from '@/components/LazyComponent';

const UpdateSavedInventory = dynamic(() => import('reaxl-molecules/es/UpdateSavedInventory'), { ssr: false });
/**
 * UpdateSavedInventoryContainer
 * Enables update of saved inventory
 */

const UpdateSavedInventoryContainer = memo(({
    onSaveInventoryUpdate = () => { },
    onEmailAlertToggle = () => { },
    onTextAlertToggle = () => { },
}) => {
    const dispatch = useDispatch();
    const updateSavedInventoryState = useSelector(savedInventoryDuck.selectors.getUpdateSavedInventoryState);

    const hideUpdateSavedInventory = () => dispatch(savedInventoryDuck.creators.hideUpdateSavedInventory());
    const updateSavedInventoryItem = (data, callback) => dispatch(savedInventoryDuck.creators.updateSavedInventoryItem(data, callback));

    const handleSaveInventoryUpdate = () => {
        let disable = false;
        return async (data) => {
            if (!disable) {
                disable = true;
                await updateSavedInventoryItem(data, () => { });
                onSaveInventoryUpdate(data);
                disable = false;
            }
        };
    };

    return (updateSavedInventoryState.show
        && (
            <LazyComponent fallback={null}>
                <ErrorBoundary>
                    <UpdateSavedInventory
                        key="updateSavedInventory"
                        {...updateSavedInventoryState}
                        btnContext={updateSavedInventoryState.animatedButtonState}
                        onHide={hideUpdateSavedInventory}
                        onSubmit={handleSaveInventoryUpdate()}
                        onEmailAlertToggle={onEmailAlertToggle}
                        onTextAlertToggle={onTextAlertToggle}
                    />
                </ErrorBoundary>
            </LazyComponent>
        )
    );
});

UpdateSavedInventoryContainer.propTypes = {
    /**
     * Callback fires after saved inventory is updated
     */
    onSaveInventoryUpdate: PropTypes.func,
    /**
     * object for update saved inventory modal form
     */
    updateSavedInventoryState: PropTypes.object,
};

export default UpdateSavedInventoryContainer;
